import styled from "styled-components";
import {SIZES} from "@/components/constants";
import Icon01 from "@public/assets/service/PC_02_01.png"
import Icon02 from "@public/assets/service/PC_02_02.png"
import Icon03 from "@public/assets/service/PC_02_03.png"
import {useSectionActive} from "@/app/[locale]/services/useSectionActive";
import {useEffect, useRef} from "react";
import {useMediaQuery} from "react-responsive";

const InformationSection = ({ data, index, activeIndex }) => {
    const sectionRef = useRef();


    const isTablet = useMediaQuery(
        { query: `(max-width: ${SIZES.TABLET})` },
        undefined,
        () => false
    );
    const sectionActive = index <= activeIndex;
    const titleRef = useSectionActive(sectionActive);
    const item01Ref = useSectionActive(sectionActive,{
        offset: isTablet ? 0 : 20,
        delay: isTablet ? 0 : 0.2,
    });
    const item02Ref = useSectionActive(sectionActive,{
        offset: isTablet ? 0 : 20,
        delay: isTablet ? 0 : 0.4,
    });

    const item03Ref = useSectionActive(sectionActive,{
        offset: isTablet ? 0 : 20,
        delay: isTablet ? 0 : 0.6,
    });
    useEffect(() => {

        const setHeights = () => {

            const wrapper = sectionRef?.current?.querySelector(".info-wrapper");
            if (!wrapper) return;
            const items = wrapper.querySelectorAll(".info-item");
            const cardTops = wrapper.querySelectorAll(".card-top");

            if (!items.length || !cardTops.length) return;

            // reset
            cardTops.forEach(el => el.style.minHeight = "auto");
            items.forEach(el => el.style.minHeight = "auto");

            // card-top max height
            let maxCardTopHeight = 0;

            cardTops.forEach(el => {
                const h = el.offsetHeight;
                if (h > maxCardTopHeight) maxCardTopHeight = h;
            });

            cardTops.forEach(el => {
                el.style.minHeight = `${maxCardTopHeight}px`;
            });

            // info-item max height
            let maxItemHeight = 0;

            items.forEach(el => {
                const h = el.offsetHeight;
                if (h > maxItemHeight) maxItemHeight = h;
            });

            items.forEach(el => {
                el.style.minHeight = `${maxItemHeight}px`;
            });

        };

        const init = () => {
            setTimeout(setHeights, 50);
        };

        init();

        window.addEventListener("resize", setHeights);

        return () => {
            window.removeEventListener("resize", setHeights);
        };

    }, []);



    return(
        <SectionWrap ref={sectionRef}>
            <div className={"container"}>
                <div className={"title-wrap"} ref={titleRef}>
                    <p dangerouslySetInnerHTML={{__html: data["service-pr2-title"]}}/>
                </div>
                <div className={"info-wrapper"}>

                    <div className={"info-item"} ref={item01Ref}>
                        <div className={"card-top item01"}>
                            <img src={Icon01?.src} alt={"렌탈 서비스 Type"}/>
                            <div className={"card-top-wrap"}>
                                <p
                                    className={"card-top-title"}
                                    dangerouslySetInnerHTML={{__html: data["service-pr2-card1-top"]}}
                                />
                                <h3
                                    className={"card-top-sub"}
                                    dangerouslySetInnerHTML={{__html: data["service-pr2-card1-title"]}}
                                />
                            </div>
                        </div>
                        <div className={"card-body"}>
                            <p
                                className={"card-body-desc"}
                                dangerouslySetInnerHTML={{__html: data["service-pr2-card1-desc"]}}
                            />
                            <div className={"card-body-line"}></div>
                            <div className={"card-body-center"}>
                                <div className={"card-body-title-wrap"}>
                                    <span
                                        className={"body-label"}
                                        dangerouslySetInnerHTML={{__html: data["service-pr2-card1-text1"]}}
                                    />
                                </div>
                                <div className={"body-tags"}>
                                    <span
                                        className={"tag"}
                                        dangerouslySetInnerHTML={{__html: data["service-pr2-card1-text2"]}}
                                    />
                                    <span
                                        className={"tag"}
                                        dangerouslySetInnerHTML={{__html: data["service-pr2-card1-text3"]}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={"info-item"} ref={item02Ref}>
                        <div className={"card-top item02"}>
                            <img src={Icon02?.src} alt={"구독&회수/세척"}/>
                            <div className={"card-top-wrap"}>
                                <p
                                    className={"card-top-title"}
                                    dangerouslySetInnerHTML={{__html: data["service-pr2-card2-top"]}}
                                />
                                <h3
                                    className={"card-top-sub"}
                                    dangerouslySetInnerHTML={{__html: data["service-pr2-card2-title"]}}
                                />
                            </div>
                        </div>
                        <div className={"card-body"}>
                            <p
                                className={"card-body-desc"}
                                dangerouslySetInnerHTML={{__html: data["service-pr2-card2-desc"]}}
                            />
                            <div className={"card-body-line"}></div>
                            <div className={"card-body-center"}>
                                <div className={"card-body-title-wrap"}>
                                     <span
                                         className={"body-label"}
                                         dangerouslySetInnerHTML={{__html: data["service-pr2-card1-text1"]}}
                                     />
                                </div>
                                <div className={"body-tags"}>
                                    <span
                                        className={"tag"}
                                        dangerouslySetInnerHTML={{__html: data["service-pr2-card2-text2"]}}
                                    />
                                    <span
                                        className={"tag"}
                                        dangerouslySetInnerHTML={{__html: data["service-pr2-card2-text3"]}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={"info-item"} ref={item03Ref}>
                        <div className={"card-top item03"}>
                            <img src={Icon03?.src} alt={"통합 온배송"}/>
                            <div className={"card-top-wrap"}>
                                <p
                                    className={"card-top-title"}
                                    dangerouslySetInnerHTML={{__html: data["service-pr2-card3-top"]}}
                                />
                                <h3
                                    className={"card-top-sub"}
                                    dangerouslySetInnerHTML={{__html: data["service-pr2-card3-title"]}}
                                />
                            </div>
                        </div>


                        <div className={"card-body"}>
                            <p
                                className={"card-body-desc"}
                                dangerouslySetInnerHTML={{__html: data["service-pr2-card3-desc"]}}
                            />
                            <div className={"card-body-line"}></div>
                            <div className={"card-body-center"}>
                                <div className={"card-body-title-wrap"}>
                                    <span
                                        className={"body-label"}
                                        dangerouslySetInnerHTML={{__html: data["service-pr2-card1-text1"]}}
                                    />
                                </div>
                                <div className={"body-tags"}>
                                    <span
                                        className={"tag"}
                                        dangerouslySetInnerHTML={{__html: data["service-pr2-card3-text2"]}}
                                    />
                                    <span
                                        className={"tag"}
                                        dangerouslySetInnerHTML={{__html: data["service-pr2-card3-text3"]}}
                                    />
                                    <span
                                        className={"tag"}
                                        dangerouslySetInnerHTML={{__html: data["service-pr2-card3-text4"]}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </SectionWrap>
    )
}
const SectionWrap = styled.section`
    padding: 80px 0;
    gap: 120px;
    display: flex;
    flex-direction: column;
    .title-wrap,
    .info-item {
        opacity: 0;
        transform: translateY(60px);
        transition: all 0.6s ease;
    }

    .title-wrap.is-show,
    .info-item.is-show {
        opacity: 1;
        transform: translateY(0);
    }
    .container {
        width: 100%;
        margin: 0 auto;
        padding: 0 24px;
        .title-wrap{
            line-height: 0;
            margin-bottom: 64px;
            font-size: 40px;
            font-weight: 700;
            p{
                line-height: 1.6;
            }
        }
        .info-wrapper{
            display: grid;
            gap: 24px;
            grid-template-columns: 1fr 1fr;
            .info-item{
                background: #fff;
                border-radius: 22px;
                overflow: hidden;
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
                border: 1px solid #e5e7eb;
          
                .card-top{
                    padding: 24px 24px 28px;
                    color: #fff;
                    text-align: left;
                    position: relative;
                    background: #4BA8A2;
                    &.item02{
                        background: #17A66E;
                    }
                    &.item03{
                        background: #0F8535;
                    }
                    img{
                        width: auto;
                        margin-bottom: 16px;
                    }
                    .card-top-wrap{
                        .card-top-title{
                            font-size: 18px;
                            line-height: 28px;
                        }
                        .card-top-sub{
                            font-size: 38px;
                            font-weight: 700;
                            line-height: 56px;
                            margin: 8px 0 0;
                        }
                    }
                }
                .card-body{
                    padding: 26px 24px 28px;
                    .card-body-desc{
                        font-size: 24px;
                        line-height: 1.55;
                        color: #5F5D67;
                        b{
                            font-weight: 700;
                            color: #000;
                        }
                    }
                    .card-body-line{
                        border-top: 1px solid #ddd;
                        margin: 20px 0 20px;
                    }
                    .card-body-center{
                        display: flex;
                        align-items: center;
                        height: 164px;
                        .card-body-title-wrap{
                            padding: 16px;
                            span{
                                color: #07903A;
                                font-weight: 400;
                                font-size: 22px;
                            }
                        }
                        .body-tags{
                            display: flex;
                            flex-direction: column;
                            gap: 10px;
                            .tag{
                                display: inline-flex;
                                padding: 8px 14px;
                                background: #fff;
                                border: 1px solid #f0f0f1;
                                border-radius: 20px;
                                font-size: 22px;
                                //color: #5F5D6;
                                width: fit-content;
                            }
                        }
                    }
                }
            }
        }
    }
    @media (max-width: ${SIZES.MOBILE}) {
        .container {
            .info-wrapper{
                .info-item{
                    .card-top{
                        display: flex;
                        align-items: center;
                        gap: 20px;
                        img{
                            margin: 0;
                        }
                        .card-top-wrap{
                            .card-top-title{
                                font-size: 13px;
                                line-height: 20px;
                            }
                            .card-top-sub{
                                font-size: 20px;
                                line-height: 30px;
                            }
                        }
                    }
                    .card-body{
                        .card-body-desc{
                            font-size: 14px;
                            b{
                                font-size: 18px;
                                display: inline-block;
                                padding-bottom: 10px;
                            }
                        }
                        .card-body-center{
                            height: 118px;
                            .card-body-title-wrap{
                                span{
                                    font-size: 14px;
                                }
                            }
                            .body-tags{
                                .tag{
                                    font-size: 14px;
                                    padding: 9px 15px;
                                    color: #5F5D67;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .container {
            .title-wrap{
                font-size: 18px;
                margin-bottom: 32px;
            }
            .info-wrapper{
                grid-template-columns: 1fr;
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;

        }
    }

    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;
            .info-wrapper{
                grid-template-columns: repeat(3, minmax(0, 1fr));
            }
        }
    }

    @media (min-width: ${SIZES.TABLET}) {
        gap: 133px;
        .container {
            max-width: 1024px;
            padding: 0 40px;
            gap: 70px;

        }
    }

    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;

        }
    }

    @media screen and (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;

        }
    }
`
export default InformationSection;